export default __webpack_public_path__ + "static/logoWithAV-8901656c147b2bda98e5b576dc437225.svg";